"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zh = void 0;
exports.zh = {
    'Confirm Email': '确认电子邮件',
    'Confirm Password': '确认密码',
    'Email': '电邮',
    'Error button name': '重新开始',
    'Error contact sales': '我们无法完成您的请求，请重试。如果问题仍然存在，请联系 sales@ff.com 或 1.800.228.7702 以获得即时支持。',
    'Error title': '抱歉',
    'First Name': '名',
    'Last Name': '姓',
    'Password': '密码',
    'Phone Number': '电话号码',
    'Please enter a valid CN phone number': '请输入有效的中国电话号码',
    'Please enter a valid email address': '请输入有效的电邮',
    'Please enter a valid US phone number': '请输入有效的美国电话号码',
    'Required': '必需'
};
